import React from 'react';

export default function SunWizardCloakSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="22.07,27.42 9.16,27.42 8.33,20.3 21.24,20.3" fill="#CC944D" />
      <polygon points="22.07,27.42 9.16,27.42 8.33,20.3 21.24,20.3" fill="#CC944D" />
      <polygon points="22.82,38.0 9.91,38.0 12.32,19.82 25.23,19.82" fill="#CC944D" />
      <polygon points="9.91,38.0 22.82,38.0 21.7,35.9 8.79,35.9" fill="#8B5F27" opacity="0.95" />
      <polygon points="9.91,38.0 8.79,35.9 11.2,17.72 12.32,19.82" fill="#8B5F27" opacity="0.95" />
      <polygon points="22.82,38.0 9.91,38.0 12.32,19.82 25.23,19.82" fill="#CC944D" />
      <polygon points="9.91,38.0 22.82,38.0 21.7,35.9 8.79,35.9" fill="#8B5F27" opacity="0.95" />
      <polygon points="9.91,38.0 8.79,35.9 11.2,17.72 12.32,19.82" fill="#8B5F27" opacity="0.95" />
      <polygon points="22.82,38.0 9.91,38.0 12.32,19.82 25.23,19.82" fill="#CC944D" />
      <polygon points="9.91,38.0 22.82,38.0 21.7,35.9 8.79,35.9" fill="#8B5F27" opacity="0.95" />
      <polygon points="9.91,38.0 8.79,35.9 11.2,17.72 12.32,19.82" fill="#8B5F27" opacity="0.95" />
      <polygon points="22.82,38.0 9.91,38.0 12.32,19.82 25.23,19.82" fill="#CC944D" />
      <polygon points="9.91,38.0 22.82,38.0 21.7,35.9 8.79,35.9" fill="#8B5F27" opacity="0.95" />
      <polygon points="9.91,38.0 8.79,35.9 11.2,17.72 12.32,19.82" fill="#8B5F27" opacity="0.95" />
      <polygon points="23.71,22.67 15.64,22.67 14.9,16.34 22.97,16.34" fill="#CC944D" />
      <polygon points="15.64,22.67 23.71,22.67 21.7,24.44 13.63,24.44" fill="#8B5F27" opacity="0.95" />
      <polygon points="15.64,22.67 13.63,24.44 12.89,18.11 14.9,16.34" fill="#8B5F27" opacity="0.95" />
      <polygon points="23.71,22.67 15.64,22.67 14.9,16.34 22.97,16.34" fill="#CC944D" />
      <polygon points="15.64,22.67 23.71,22.67 21.7,24.44 13.63,24.44" fill="#8B5F27" opacity="0.95" />
      <polygon points="15.64,22.67 13.63,24.44 12.89,18.11 14.9,16.34" fill="#8B5F27" opacity="0.95" />
      <polygon points="31.67,22.98 10.69,22.98 10.69,2.0 31.67,2.0" fill="#CC944D" />
      <polygon points="14.85,36.15 27.76,36.15 26.06,35.3 13.15,35.3" fill="#8B5F27" opacity="0.95" />
      <polygon points="14.85,36.15 27.76,36.15 26.06,35.3 13.15,35.3" fill="#8B5F27" opacity="0.95" />
    </svg>
  );
}
